import { inject, Injectable } from '@angular/core'
import { FileUpload, FileUploadService } from '../file-upload.service'
import { PdfViewerComponent } from '../../features/documents/document-viewers/pdf-viewer/pdf-viewer.component'
import { ModalController } from '@ionic/angular'
import { downloadFromDataUrl } from '../utils'

@Injectable({
  providedIn: 'root',
})
export class FileViewerService {
  private modalCtrl = inject(ModalController)
  private fileUploadService = inject(FileUploadService)

  async viewIfPdfElseDownload(fileUri: string) {
    await this.fileUploadService.get(fileUri).then(async (res: FileUpload) => {
      const base64File: string = res.uri
      if (base64File.startsWith('data:application/pdf') && res.size < 5000000) {
        // 5 MB
        await this.viewPdfInModal(base64File)
      } else {
        await downloadFromDataUrl(res.uri, FileUploadService.parseFileNameFromUrl(fileUri))
      }
    })
  }

  async viewPdfRemote(fileUri: string) {
    await this.fileUploadService.get(fileUri).then(async (res: FileUpload) => {
      await this.viewPdf(res)
    })
  }

  async viewPdf(fileUpload: FileUpload) {
    const base64File: string = fileUpload.uri
    console.log(base64File)
    if (base64File.startsWith('data:application/pdf')) {
      await this.viewPdfInModal(base64File)
    }
  }

  async viewPdfInModal(pdfBase64: string) {
    const modal = await this.modalCtrl.create({
      component: PdfViewerComponent,
      componentProps: {
        src: pdfBase64,
      },
      cssClass: 'pdfViewerModal',
    })
    await modal.present()
    return
  }
}
